"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadStatus = void 0;
var _user = require("./user");
var ReadStatus = exports.ReadStatus = /*#__PURE__*/function (ReadStatus) {
  ReadStatus[ReadStatus["UNREAD"] = 0] = "UNREAD";
  ReadStatus[ReadStatus["SENT"] = 1] = "SENT";
  ReadStatus[ReadStatus["READ"] = 2] = "READ";
  return ReadStatus;
}({});